export default "__VITE_ASSET__ac7228c8__"